import { investingApi } from "../../services/api";
import FundPositions from "./FundPositions";
import ScoreboardLine from "./ScoreboardLine";
import ScoreboardPanel from "./ScoreboardPanel";
import UnauthorizedBanner from "./UnauthorizedBanner";
import useLatestSnapshot from "./useLatestSnapshot";
import useRead from "./useRead";
import useScoreboardSeries from "./useScoreboardSeries";

/**
 * The Fund page (spec §5.5, walkthrough 11), at /investing/fund: the
 * scoreboard — the account against the same money held in the benchmark,
 * at the latest snapshot (GET scoreboard/), and how each figure is computed
 * — its line over every snapshot, and the positions as of the latest
 * snapshot beside the approved target's weights, and cash. Anyone signed in
 * reads it; nothing else here decides anything. Above it all, the red
 * banner: any unauthorized fill not yet acknowledged (walkthrough 10). Each part loads, fails and
 * retries on its own; before the first snapshot each says what comes next.
 */
function InvestingFund() {
  const latest = useLatestSnapshot();
  const board = useRead(investingApi.scoreboard.get);
  const target = useRead(investingApi.target.get);
  const line = useScoreboardSeries();

  return (
    <div className="page-container mt-6 pt-4">
      <div className="max-w-4xl">
        <header className="mb-4">
          <h1 className="mb-1 font-display text-3xl font-semibold tracking-tight">Fund</h1>
          <p className="m-0 text-sm text-muted-foreground">
            The account as your executor last read it: how it stands against the same money held in the benchmark
            (the scoreboard), how that has moved, and each position beside its target weight. The figures come from the
            executor&apos;s snapshots — Mono never reads Robinhood itself, and nothing on this page trades.
          </p>
        </header>
        <UnauthorizedBanner />
        <div className="flex flex-col gap-4">
          <ScoreboardPanel state={board} />
          <ScoreboardLine line={line} board={board.data} />
          <FundPositions latest={latest} target={target} />
        </div>
      </div>
    </div>
  );
}

export default InvestingFund;
